<template>
    <a :href="url" class="phototheque-card">
        <div class="phototheque-card__title" v-html="title"></div>
        <p class="phototheque-card__content" v-html="content"></p>
        <div class="phototheque-card__button">
            <span class="rounded-button" v-html="title"></span>
        </div>
    </a>
</template>

<script>
    export default {
        name: 'PhotothequeCard',

        props: {
            title:   { type: String, required: true },
            content: { type: String, required: true },
            url:     { type: String, required: true },
        },
    };
</script>

<style scoped lang="scss">
    @import '../../assets/styles/abstracts/variables';
    @import '../../assets/styles/abstracts/placeholders';

    .phototheque-card {
        display:         flex;
        flex-direction:  column;
        justify-content: start;

        // Fix for IE11
        flex:            0 0 auto;
        width:           100%;

        margin-bottom:   3rem;
        padding:         1.7rem 2rem 2rem;

        border:          0.1rem solid $gray-300;
        background:      white;
        text-decoration: none;

        color:           $gray-500;

        @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
            padding: 2rem 3rem 3rem;
        }

        &__title {
            @extend %font-OpenSans-bold;

            font-size: 1.6rem;
            color:           $gray-500;

            @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
                font-size: 2.4rem;
            }
        }

        &__content {
            font-size:       1.6rem;
            color:           $gray-500;
            line-height:     (24/16);

            margin-bottom: 1.9rem;
        }

        &__button {
            margin: 0 auto;
        }
    }
</style>
